import React from "react";

function SvgIcMapPoi120(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M19.046 13.025a6.49 6.49 0 01.56-2.025h5.785c.28.597.477 1.285.56 2.025h-6.905zm7.857 2.124c.07-.424.096-.959.096-1.316 0-1.156-.243-2.283-.703-3.259A1.001 1.001 0 0025.39 10h-5.785a1 1 0 00-.904.574c-.46.976-.703 2.103-.703 3.259 0 .353.025.886.096 1.321.446 2.797 2.34 4.08 3.404 4.592v3.389c-1.065.278-2.016.977-2.537 1.865h7c-.512-.875-1.423-1.548-2.462-1.84v-3.416c1.065-.513 2.957-1.797 3.403-4.595zm-11.91-4.122c0 .587-.1 1.298-.235 1.998H6.244c-.132-.69-.227-1.407-.227-2.038 0-1.89.003-1.962.003-1.962h8.982s-.008.142-.008 2.002m.013-3.002H6.02a1 1 0 00-.7.285c-.304.298-.304.298-.304 2.677 0 1.984.83 4.647 1.017 5.217l.87 7.88a1 1 0 00.995.89h5.182a.999.999 0 00.993-.885l.9-7.874c.176-.564 1.02-3.363 1.02-5.188 0-1.333.004-1.77.006-1.91a.998.998 0 00-.993-1.093"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi120;
